import React, { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';

import Mobile from 'components/Shared/Icons/Mobile';
import { colors, fontSize } from 'styles/cp';

const IntuitAccountBanner: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Trigger animation after a short delay for smooth transition
    const timer = setTimeout(() => setIsVisible(true), 0);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className={`intuit-account-banner ${isVisible ? 'visible' : ''}`}>
      <div className="banner-content">
        <Mobile color={colors.pepper50} />
        <div className="banner-text">
          <div className="banner-title">
            <FormattedMessage
              id="INTUIT_ACCOUNT_BANNER_TITLE"
              defaultMessage="Enter to create an Intuit account and securely save info for future payments."
            />
          </div>
          <div className="banner-subtitle">
            <FormattedMessage
              id="INTUIT_ACCOUNT_BANNER_SUBTITLE"
              defaultMessage="We'll send a code to your phone to verify it's you once you select 'Agree and pay'. Standard call or SMS rates may apply."
            />
          </div>
        </div>
      </div>

      {/*language=SCSS*/}
      <style jsx>{`
        .intuit-account-banner {
          background-color: ${colors.pepper0};
          border: 1px solid ${colors.stoneWhite};
          border-radius: 0 0 3px 3px;
          padding: 0 14px;
          overflow: hidden;
          max-height: 0;
          opacity: 0;
          transform: translateY(-10px);
          transition: all 0.6s ease-out;

          &.visible {
            max-height: 120px;
            padding: 10px 14px;
            opacity: 1;
            transform: translateY(0);
          }

          .banner-content {
            display: flex;
            align-items: center;
            gap: 12px;
          }

          .banner-text {
            flex: 1;
            font-size: ${fontSize.xxxs};
          }

          .banner-title {
            font-family: AvenirNextforINTUIT-Medium;
            color: ${colors.gray};
            margin-bottom: 3px;
          }

          .banner-subtitle {
            font-family: AvenirNextforINTUIT-Regular;
            color: ${colors.gray02};
          }
        }
      `}</style>
    </div>
  );
};

export { IntuitAccountBanner };
